import React, { useState, useRef } from "react";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import { OverlayPanel } from 'primereact/overlaypanel';
import { Steps } from 'primereact/steps';
import { ScrollPanel } from 'primereact/scrollpanel';
import { METAMODELO, TIPOS_NIVEIS_ORGANIZACIONAIS } from '../../../utils/Metamodelo.js';
import { Toast } from 'primereact/toast';
import { Route } from 'react-router-dom';

import "./styles.css";

const QuestionarioConfiguracao = ({ questionario, setQuestionario, setFluxoGerenciamento }) => {

    //hooks react
    const [selectedCard, setSelectedCard] = useState('grupo');
    const [selectedGrupo, setSelectedGrupo] = useState(0);
    const op = useRef(null);
    
    let idRefQuestao = useRef(1);

    const gerarIdQuestao = () =>{
        return idRefQuestao.current++;
    }

    const moveQuestionUp = () => {
        if (selectedCard === 'grupo') {
            if (selectedGrupo > 0) {
                const updatedGruposQuestoes = [...questionario.gruposQuestoes];
                const selectedGroup = updatedGruposQuestoes[selectedGrupo];
                updatedGruposQuestoes[selectedGrupo] = updatedGruposQuestoes[selectedGrupo - 1];
                updatedGruposQuestoes[selectedGrupo - 1] = selectedGroup;

                setQuestionario((prevState) => ({
                    ...prevState,
                    gruposQuestoes: updatedGruposQuestoes,
                }));
                setSelectedGrupo(selectedGrupo - 1);
            }
        } else if (selectedCard >= 0) {
            const selectedGroup = questionario.gruposQuestoes[selectedGrupo];
            if (selectedCard > 0) {
                const updatedQuestions = [...selectedGroup.questoes];
                const selectedQuestion = updatedQuestions[selectedCard];
                updatedQuestions[selectedCard] = updatedQuestions[selectedCard - 1];
                updatedQuestions[selectedCard - 1] = selectedQuestion;

                const updatedGruposQuestoes = [...questionario.gruposQuestoes];
                updatedGruposQuestoes[selectedGrupo] = {
                    ...selectedGroup,
                    questoes: updatedQuestions,
                };

                setQuestionario((prevState) => ({
                    ...prevState,
                    gruposQuestoes: updatedGruposQuestoes,
                }));
                setSelectedCard(selectedCard - 1);
            }
        }
    };

    const moveQuestionDown = () => {
        if (selectedCard === 'grupo') {
            if (selectedGrupo < questionario.gruposQuestoes.length - 1) {
                const updatedGruposQuestoes = [...questionario.gruposQuestoes];
                const selectedGroup = updatedGruposQuestoes[selectedGrupo];
                updatedGruposQuestoes[selectedGrupo] = updatedGruposQuestoes[selectedGrupo + 1];
                updatedGruposQuestoes[selectedGrupo + 1] = selectedGroup;

                setQuestionario((prevState) => ({
                    ...prevState,
                    gruposQuestoes: updatedGruposQuestoes,
                }));
                setSelectedGrupo(selectedGrupo + 1);
            }
        } else if (selectedCard >= 0) {
            const selectedGroup = questionario.gruposQuestoes[selectedGrupo];
            if (selectedCard < selectedGroup.questoes.length - 1) {
                const updatedQuestions = [...selectedGroup.questoes];
                const selectedQuestion = updatedQuestions[selectedCard];
                updatedQuestions[selectedCard] = updatedQuestions[selectedCard + 1];
                updatedQuestions[selectedCard + 1] = selectedQuestion;

                const updatedGruposQuestoes = [...questionario.gruposQuestoes];
                updatedGruposQuestoes[selectedGrupo] = {
                    ...selectedGroup,
                    questoes: updatedQuestions,
                };

                setQuestionario((prevState) => ({
                    ...prevState,
                    gruposQuestoes: updatedGruposQuestoes,
                }));
                setSelectedCard(selectedCard + 1);
            }
        }
    };

    const deleteItem = () => {
        if (selectedCard === 'grupo') {
            const gruposQuestoes = [...questionario.gruposQuestoes];

            // Verifique se há mais de um grupo antes de excluir
            if (gruposQuestoes.length > 1) {
                gruposQuestoes.splice(selectedGrupo, 1);
            } else {
                // Se houver apenas um grupo, crie um novo grupo limpo em vez de excluir
                gruposQuestoes[selectedGrupo] = {
                    titulo: '',
                    descricao: '',
                    questoes: []
                };
            }
            showSuccessToast('Grupo removido!');
            // Atualize selectedGrupo para apontar para o último grupo ou um grupo válido
            setSelectedGrupo(Math.min(selectedGrupo, gruposQuestoes.length - 1));

            setQuestionario((prevState) => ({
                ...prevState,
                gruposQuestoes,
            }));

            // Defina o card selecionado de volta para 'grupo' após a exclusão
            setSelectedCard('grupo');
        } else {
            const updatedQuestions = [...questionario.gruposQuestoes[selectedGrupo].questoes];
            updatedQuestions.splice(selectedCard, 1);

            const updatedGruposQuestoes = [...questionario.gruposQuestoes];
            updatedGruposQuestoes[selectedGrupo] = {
                ...updatedGruposQuestoes[selectedGrupo],
                questoes: updatedQuestions,
            };
            showSuccessToast('Questão removida!');

            setQuestionario((prevState) => ({
                ...prevState,
                gruposQuestoes: updatedGruposQuestoes,
            }));

            // Defina o card selecionado de volta para 'grupo' após a exclusão
            setSelectedCard('grupo');
        }
    };

    const toast = useRef(null);

    // Função para exibir um aviso de sucesso
    const showSuccessToast = (message) => {
        toast.current.show({ severity: 'success', summary: 'Sucesso', detail: message });
    };

    // Função para exibir um aviso de erro
    const showErrorToast = (message) => {
        toast.current.show({ severity: 'error', summary: 'Erro', detail: message });
    };

    const verifiTituloDuplicado = (newTitle) => {
        // Verifique se o novo título já existe em outros grupos (exceto o grupo atual)
        const isDuplicate = questionario.gruposQuestoes.some((grupo, index) => {
            return grupo.titulo === newTitle && index !== selectedGrupo;
        });
        return isDuplicate;
    }

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    };

    const header = renderHeader();

    console.log(questionario)
    //renderização dos componentes da pagina
    return (
        <div className="main-content">
            <div className="navegacao">
                <div className="paginacao">
                    <Steps model={questionario.gruposQuestoes} activeIndex={selectedGrupo} onSelect={(e) => {setSelectedGrupo(e.index); setSelectedCard('grupo')}} readOnly={false} />
                </div>
                <div className="grupo-title">
                    <div dangerouslySetInnerHTML={{ __html: questionario.gruposQuestoes[selectedGrupo].titulo }} />
                </div>
                <Route render={(props) => (
                    <div className="botoes">
                        <Button className='p-button-danger' label='RETROCEDER' icon='pi pi-arrow-left' onClick={() => {
                            setFluxoGerenciamento('InicioConfigQ')
                        }} />
                        <Button className='p-button-success' label='AVANÇAR' icon='pi pi-arrow-right' iconPos="right" style={{background: "#4caf50", width: "1.8in"}} onClick={() => {
                            setFluxoGerenciamento('FimConfigQ')
                        }} />
                    </div>
                )} />
            </div>
            <div className="edicao" style={{ height: '600px' }}>
                <div className="lateral-menu">
                <div className="lateral-menu-painel">
                        <div>
                            <Button id="personal-only-icon" icon="pi pi-plus" onClick={(e) => op.current.toggle(e)} />
                            <OverlayPanel id="overlay-button" ref={op}>
                                <Button id="button-inline" label="NOVO GRUPO" className="w-full" onClick={() =>{
                                        questionario.gruposQuestoes.push({
                                            titulo: '',
                                            descricao: '',
                                            questoes: []
                                        })
                                        setSelectedGrupo(questionario.gruposQuestoes.length - 1)
                                        setSelectedCard('grupo')
                                        setQuestionario(questionario);
                                        showSuccessToast('Novo grupo criado!');
                                    }
                                }/>
                                <Button id="button-inline" label="QUESTÃO FECHADA" className="w-full" onClick={() =>{
                                    const grupoAtual = questionario.gruposQuestoes[selectedGrupo];

                                    if (grupoAtual.titulo.trim() !== '') {
                                        const grupoIndex = selectedGrupo
                                        const questaoIndex = questionario.gruposQuestoes[grupoIndex].questoes.length

                                        questionario.gruposQuestoes[selectedGrupo].questoes.push({
                                            id: `G${grupoIndex + 1}_Q${questaoIndex + 1}`,
                                            tipo: 'DIMENSIONALIZADA_FECHADA',
                                            titulo: '',
                                            descricao: '',
                                            sinaesEixo: METAMODELO.getEixoByTitulo(grupoAtual.titulo),
                                            sinaesDimensao: METAMODELO.getDimensaoByTitulo(grupoAtual.titulo),
                                            nivelOrganizacional: '',
                                            segmentos: [questionario.filtrosParticipante.segmento[0]],
                                            indicadores: []
                                        })
                                        setSelectedCard(questionario.gruposQuestoes[selectedGrupo].questoes.length - 1)
                                        setQuestionario(questionario);
                                        showSuccessToast('Questão fechada criada!');
                                    } else {
                                        showErrorToast('O grupo precisa de um título antes de adicionar uma questão.');
                                    }
                                }}/>
                                <Button id="button-inline" label="QUESTÃO ABERTA" className="w-full" onClick={() =>{
                                    const grupoAtual = questionario.gruposQuestoes[selectedGrupo];

                                    if (grupoAtual.titulo.trim() !== '') {
                                        const grupoIndex = selectedGrupo
                                        const questaoIndex = questionario.gruposQuestoes[grupoIndex].questoes.length

                                        questionario.gruposQuestoes[selectedGrupo].questoes.push({
                                            id: `G${grupoIndex + 1}_Q${questaoIndex + 1}`,
                                            tipo: 'DIMENSIONALIZADA_ABERTA',
                                            titulo: '',
                                            descricao: '',
                                            sinaesEixo: METAMODELO.getEixoByTitulo(grupoAtual.titulo),
                                            sinaesDimensao: METAMODELO.getDimensaoByTitulo(grupoAtual.titulo),
                                            nivelOrganizacional: '',
                                            segmentos: [questionario.filtrosParticipante.segmento[0]],
                                        })
                                        setSelectedCard(questionario.gruposQuestoes[selectedGrupo].questoes.length - 1)
                                        setQuestionario(questionario);
                                        showSuccessToast('Questão aberta criada!');
                                    } else {
                                        showErrorToast('O grupo precisa de um título antes de adicionar uma questão.');
                                    }
                                }}/>
                            </OverlayPanel>
                        </div>
                        {/* Botões de mover (últimos - à direita) */}
                        <div className="button-group move-buttons">
                            <Button id="personal-only-icon" icon="pi pi-caret-up" title="Mover para cima" onClick={moveQuestionUp}/>
                            <Button id="personal-only-icon" icon="pi pi-caret-down" title="Mover para baixo" onClick={moveQuestionDown}/>
                        </div>
                    </div>
                    <ScrollPanel style={{ width: '100%', height: 'calc(100% - 40px)' }}>
                        <div className="lateral-menu-content">
                            <div onClick={() => setSelectedCard('grupo')}>
                                <Card
                                    id={`${selectedCard === 'grupo' ? 'selected' : 'lateral-card'}`}
                                    title="GRUPO"
                                className={selectedCard === 'grupo' ? 'selected-text' : ''}
                                >
                                    <p>{questionario.gruposQuestoes[selectedGrupo].titulo}</p>
                                </Card>
                            </div>
                            {questionario.gruposQuestoes[selectedGrupo].questoes.map((question, index) => (
                                <div onClick={() => setSelectedCard(index)}>
                                    <Card
                                    key={index}
                                    id={`${selectedCard === index ? 'selected' : 'lateral-card'}`}
                                    className="question-card"
                                    title="QUESTÃO"
                                    >
                                        <p>{<div dangerouslySetInnerHTML={{ __html:question.titulo}}/>}</p>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    </ScrollPanel>
                </div>

                <ScrollPanel style={{ width: '100%', height: '100%' }}>
                <div className="question-content" style={{ minHeight: '600px' }}>
                {selectedCard === 'grupo' && (
                    <Card title={<div id="card-tittle-button">
                        <Button className='right-aligned-button'
                            id= "gp-del-button"
                            icon="pi pi-trash"
                            title="Deletar"
                            style={{ height: '40px', width: '40px'}}
                            onClick={() => {deleteItem();}}
                        />
                        </div>} id='question-content-card'>
                        {/*Dropdown de dimensão*/}
                        <div className="grupo-dimension">
                        <label className="atributo">Titulo</label>
                        <Dropdown
                            value={questionario.gruposQuestoes[selectedGrupo].titulo}
                            options={METAMODELO.getTitleOption()}
                            onChange={(e) => {
                            if(!verifiTituloDuplicado(e.value)) {
                                const updatedGruposQuestoes = [...questionario.gruposQuestoes];
                                const grupoAtual = updatedGruposQuestoes[selectedGrupo];
                                grupoAtual.titulo = e.value;

                                grupoAtual.questoes = grupoAtual.questoes.map((questao) => ({
                                    ...questao,
                                    sinaesEixo: METAMODELO.getEixoByTitulo(grupoAtual.titulo),
                                    sinaesDimensao: METAMODELO.getDimensaoByTitulo(grupoAtual.titulo),
                                }));

                                setQuestionario((prevState) => ({
                                    ...prevState,
                                    gruposQuestoes: updatedGruposQuestoes,
                                }));
                            } else {
                                showErrorToast('Já exite grupo com mesmo eixo e dimensão.');
                            }
                        }}
                            placeholder="Selecione o titulo"
                        />
                        </div>
                        <div className="grupo-description">
                        {/*Campo de descrição do grupo*/}
                        <label className="atributo">Descrição:</label>
                        <Editor
                            key={`grupo-desc-${selectedGrupo}`}
                            rows={4}
                            onTextChange={(e) => {
                                const updatedGruposQuestoes = [...questionario.gruposQuestoes];
                                updatedGruposQuestoes[selectedGrupo].descricao = e.htmlValue;
                                setQuestionario((prevState) => ({
                                    ...prevState,
                                    gruposQuestoes: updatedGruposQuestoes,
                                }));
                            }}
                            onLoad={(quill) => {
                                const desc = questionario.gruposQuestoes[selectedGrupo].descricao;
                                if (desc) {
                                    quill.clipboard.dangerouslyPasteHTML(0, desc, 'silent');
                                }
                            }}
                        />
                        </div>
                    </Card>
                )}
                {selectedCard !== 'grupo' && questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].tipo === 'DIMENSIONALIZADA_ABERTA' && (
                    <Card title={<div id="card-tittle-button" className="tittle-div-card">
                        <div dangerouslySetInnerHTML={{ __html:questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].titulo}}/>
                        <Button className='right-aligned-button'
                            id= "quest-del-button"
                            icon="pi pi-trash"
                            title="Deletar"
                            style={{ height: '40px', width: '40px'}}
                            onClick={() => {deleteItem();}}
                        />
                        </div>} id='question-content-card'>
                        <br/>
                        <div className="questao-description">
                        {/*Titulo da questão*/}
                        <label className="atributo">Título:</label>
                        <Editor
                            key={`aberta-titulo-${selectedGrupo}-${selectedCard}`}
                            onTextChange={(e) => {
                            const updatedQuestionario = { ...questionario };
                            updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].titulo = e.htmlValue;
                            setQuestionario(updatedQuestionario);
                            }}
                            headerTemplate={header}
                            style={{ height: 'fit-content', minHeight: '0'}}
                            onLoad={(quill) => {
                                const titulo = questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].titulo;
                                if (titulo) {
                                    quill.clipboard.dangerouslyPasteHTML(0, titulo, 'silent');
                                }
                            }}
                        />
                        </div>
                        <div className="questao-description">
                        {/*Descrição da questão*/}
                        <label className="atributo">Descrição:</label>
                        <Editor
                            key={`aberta-desc-${selectedGrupo}-${selectedCard}`}
                            rows={4}
                            onTextChange={(e) => {
                            const updatedQuestionario = { ...questionario };
                            updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].descricao = e.htmlValue;
                            setQuestionario(updatedQuestionario);
                            }}
                            onLoad={(quill) => {
                                const desc = questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].descricao;
                                if (desc) {
                                    quill.clipboard.dangerouslyPasteHTML(0, desc, 'silent');
                                }
                            }}
                        />
                        </div>
                        <div className="questao-description">
                        {/*Dropdown de Nível Organizacional da questão*/}
                        <label className="atributo">Nível Organizacional:</label>
                        <Dropdown
                            value={questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].nivelOrganizacional}
                            options={TIPOS_NIVEIS_ORGANIZACIONAIS.getNivelOption()}
                            onChange={(e) => {
                            const updatedQuestionario = { ...questionario };
                            updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].nivelOrganizacional = e.value;
                            setQuestionario(updatedQuestionario);
                            }}
                            placeholder="Selecione o nível organizacional"
                        />
                        </div>
                    </Card>
                )}

                {selectedCard !== 'grupo' && questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].tipo === 'DIMENSIONALIZADA_FECHADA' && (
                        <Card title={<div id="card-tittle-button">
                            <div dangerouslySetInnerHTML={{ __html:questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].titulo}}/>
                            <Button className='right-aligned-button'
                                id= "quest-del-button"
                                icon="pi pi-trash"
                                title="Deletar"
                                style={{ height: '40px', width: '40px'}}
                                onClick={() => {deleteItem();}}
                            />
                            </div>} id='question-content-card'>
                            <div className="questao-description">
                                {/*Titulo da questão*/}
                                <label className="atributo">Título:</label>
                                <Editor
                                    key={`fechada-titulo-${selectedGrupo}-${selectedCard}`}
                                    onTextChange={(e) => {
                                        const updatedQuestionario = { ...questionario };
                                        updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].titulo = e.htmlValue;
                                        setQuestionario(updatedQuestionario);
                                    }}
                                    headerTemplate={header}
                                    style={{ height: 'fit-content', minHeight: '0'}}
                                    onLoad={(quill) => {
                                        const titulo = questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].titulo;
                                        if (titulo) {
                                            quill.clipboard.dangerouslyPasteHTML(0, titulo, 'silent');
                                        }
                                    }}
                                />
                            </div>
                            <div className="questao-description">
                                {/*Descrição da questão*/}
                                <label className="atributo">Descrição:</label>
                                <Editor
                                    key={`fechada-desc-${selectedGrupo}-${selectedCard}`}
                                    rows={4}
                                    onTextChange={(e) => {
                                        const updatedQuestionario = { ...questionario };
                                        updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].descricao = e.htmlValue;
                                        setQuestionario(updatedQuestionario);
                                    }}
                                    onLoad={(quill) => {
                                        const desc = questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].descricao;
                                        if (desc) {
                                            quill.clipboard.dangerouslyPasteHTML(0, desc, 'silent');
                                        }
                                    }}
                                />
                            </div>
                            <div className="questao-description">
                            {/*Dropdown de Nível Organizacional da questão*/}
                            <label className="atributo">Nível Organizacional:</label>
                            <Dropdown
                                value={questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].nivelOrganizacional}
                                options={TIPOS_NIVEIS_ORGANIZACIONAIS.getNivelOption()}
                                onChange={(e) => {
                                const updatedQuestionario = { ...questionario };
                                updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].nivelOrganizacional = e.value;
                                setQuestionario(updatedQuestionario);
                                }}
                                placeholder="Selecione o nível organizacional"
                            />
                            </div>
                            <div className="questao-description">
                                <label className="atributo">Indicadores:</label>
                                <Button id="personal-only-icon" icon="pi pi-plus" onClick={() => {
                                    const updatedQuestionario = { ...questionario }
                                    const grupoIndex = selectedGrupo;
                                    const questaoIndex = selectedCard;
                                    //console.log("QUESTAO INDEX " + questaoIndex)
                                    //console.log("SELECTED " + selectedCard)

                                    //console.log(updatedQuestionario.gruposQuestoes[grupoIndex].questoes[questaoIndex])
                                    const indicadorIndex = updatedQuestionario.gruposQuestoes[grupoIndex].questoes[questaoIndex].indicadores.length;
                                    updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].indicadores.push({id: `G${grupoIndex + 1}_Q${questaoIndex + 1}_I${indicadorIndex + 1}`,label: "Novo Indicador" , resposta: null})
                                    setQuestionario(updatedQuestionario);
                                    showSuccessToast('Indicador adicionado!');
                                }
                                } />
                            </div>

                            {questionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].indicadores.map((indicador, index) => (
                                <div id="indicador-content" className="questao-description" key={index}>
                                    <div>
                                        <InputText className="indicator-input-text" value={indicador.label} onChange={(e) => {
                                            const updatedQuestionario = { ...questionario };
                                            updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].indicadores[index].label = e.target.value;
                                            setQuestionario(updatedQuestionario);
                                        }} />
                                        <Button id="personal-only-icon-indicador" icon="pi pi-trash" title="Remover" onClick={() => {
                                            const updatedQuestionario = { ...questionario };
                                            updatedQuestionario.gruposQuestoes[selectedGrupo].questoes[selectedCard].indicadores.splice(index, 1);
                                            setQuestionario(updatedQuestionario);
                                            showSuccessToast('Indicador removido!');
                                        }} />
                                    </div>
                                </div>
                            ))}
                        </Card>
                    )}
                </div>
                </ScrollPanel>
            </div>
            <Toast ref={toast} />
        </div>
    )
};

export default QuestionarioConfiguracao;
